export default "__VITE_PUBLIC_ASSET__be79d8dc__"